
<b-container>
  <b-row>
    <b-col sm="12" md="12" lg="6" xl="4" v-for="category in sorted_categories" :key="category.id">
      <b-card class="mb-3">
        <b-card-title>
          {{category.name}}
        </b-card-title>
        <b-card-sub-title v-if="!!category.subtitle"  class="mb-2">
          {{category.subtitle}}
        </b-card-sub-title>
        <b-card-text>
          {{category.text}}
          <ul class="mt-3" v-if="bullets(category).length > 0">
            <li v-for="item in bullets(category)">{{item}}</li>
          </ul>
        </b-card-text>
        <b-card-img v-if="!!category.img_src" :src="category.img_src" start>
        </b-card-img>
        <b-button variant="primary" v-on:click="selectCategory(category.id)">Browse</b-button>
      </b-card>
    </b-col>
  </b-row>
</b-container>
